import { createReducer } from '@reduxjs/toolkit';
import { setNotificationsListAction } from './actions';

const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(setNotificationsListAction, (state, action) => {
    state.list = action.payload;
  })
);
